import FormattedAddress from "components/Atoms/FormattedAddress";
import React from "react";
import { isAdminAndVisitingAddressSame } from "utilities/companyUtils";
interface Props {
  company: server.dto.Company
}

export const PostalAddressPreviewPanel = ({ company }: Props) => {
  const isSameAsVisitingAddress = isAdminAndVisitingAddressSame(company);
  if (isSameAsVisitingAddress) {
    return <>{RESX.Company.SameAsVisitingAddress}</>;
  }

  return <div>
    <div>{company.admName}</div>
    <div className="text-sublabel">{company.admAddress.formatted.join(", ")}</div>
  </div>;
}

const PostalAddress = ({ company }: Props) => {
  const isSameAsVisitingAddress = isAdminAndVisitingAddressSame(company);
  if (isSameAsVisitingAddress) {
    return <>{RESX.Company.SameAsVisitingAddress}</>;
  }

  return <div>
    <div>{company.admName}</div>
    <FormattedAddress address={company.admAddress} />
  </div>
};

export default PostalAddress;